import * as types from "./action-types";
import * as fb from "../../firebase/firebasejs";
//import firebase from "firebase";
import firebase from "firebase/compat/app";

import { fechahoraNew } from "../../services/utils";
import { detalleEvento, eventSubEventsRegistry } from "./events-actions";

export function eventParticipants(eventoIndex) {
  console.log("Participantes o inscritos Evento evento");
  const ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}`
  );
  return (dispatch) => {
    ref.once("value", (snapshot) => {
      console.log(snapshot.val());
      console.log("events participan value");
      dispatch({
        type: types.EVENT_PARTICIPANTS,
        eventParticipants: snapshot.val(),
      });
    });

    ref.on("child_changed", (snapshot) => {
      console.log(snapshot.val());
      console.log("child chaged");
      dispatch({
        type: types.EVENT_PARTICIPANTS_CHANGED,
        eventParticipantsChanged: snapshot.val(),
        eventParticipantsChangedKey: snapshot.key,
      });
    });
    ref.limitToLast(1).on("child_added", (snapshot) => {
      console.log(snapshot.val());
      console.log("child added");
      dispatch({
        type: types.EVENT_PARTICIPANTS_CHANGED,
        eventParticipantsChanged: snapshot.val(),
        eventParticipantsChangedKey: snapshot.key,
      });
    });
    ref.on("child_removed", (snapshot) => {
      console.log(snapshot.val());
      console.log("child removed");
      dispatch({
        type: types.EVENT_PARTICIPANTS_REMOVED,
        eventParticipantsChanged: snapshot.val(),
        eventParticipantsChangedKey: snapshot.key,
      });
    });
  };
}
export function registryConfiguration(eventoIndex) {
  console.log("Participantes o inscritos Evento evento");
  const ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.InscripcionesConfiguracion}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      dispatch({
        type: types.REGISTRY_CONFIGURATION,
        registryConfiguration: snapshot.val(),
      });
    });
  };
}
export function registryAutorizedUsers(eventoIndex) {
  console.log("usuarios autorizados o inscritos Evento evento");
  const ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.OganizadoresEvento}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      dispatch({
        type: types.REGISTRY_AUTORIZED_USERS,
        registryAutorizedUsers: snapshot.val(),
      });
    });
  };
}

// Fija a mano registryParticipantData/registryParticipantKey en el store,
// replicando lo que ya hace el listener .on() de registryParticipantDataFunc
// — necesario para el atleta líder de un grupo (guardado con
// guardarAtletaPendienteEnGrupo, que no pasa por ese listener) porque
// PaymentsView/CardPayment.jsx leen el inscritoKey a cobrar desde
// registryParticipantKey del store, no como prop.
//
// El primer dispatch es solo para que la UI tenga algo que mostrar de
// inmediato (sin esperar un round-trip a Firebase) — pero SIN el .on()
// de abajo, el store se queda congelado con los datos de ANTES de pagar:
// la confirmación del líder del grupo nunca se entera cuando statusPago
// pasa a "ok" ni cuando el backend asigna el folio después, aunque
// RegistryConfirmation.jsx ya tenga su propia lógica para esperar el
// folio (sincronizarEsperaFolio) — esa lógica depende de recibir props
// actualizadas, que es justo lo que este .on() entrega.
export function fijarParticipanteActual(eventoIndex, inscritoKey, atleteData) {
  return (dispatch) => {
    dispatch({
      type: types.REGISTRY_PARTICIPANT_DATA,
      registryParticipantData: atleteData,
      registryParticipantKey: inscritoKey,
      registryError: null,
    });

    var route = `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}`;
    fb.db.ref(`${route}${inscritoKey}/`).on("value", (snapshot) => {
      dispatch({
        type: types.REGISTRY_PARTICIPANT_DATA,
        registryParticipantData: snapshot.val(),
        registryParticipantKey: snapshot.key,
        registryError: null,
      });
    });
  };
}

export function resetRegistryParticipantData() {
  console.log("reset");
  return (dispatch) => {
    dispatch({
      type: types.RESET_REGISTRY_PARTICIPANT_DATA,
      registryParticipantData: null,
      registryParticipantKey: null,
      registryError: null,
    });
  };
}

export function registryParticipantDataFunc(
  eventoIndex,
  atleteData,
  formaDeInscripcionparam,
  userID
) {
  //resetRegistryParticipantData();
  console.log("Guardar Datos de inscripcion");

  if (userID === undefined) {
    atleteData.usuarioRegistra = "No registrado";
  } else {
    atleteData.usuarioRegistra = userID;
  }
  atleteData.fechaRegistro = fechahoraNew();
  atleteData.serverTime = firebase.database.ServerValue.TIMESTAMP;

  // 1 Inscripcion en linea
  // 2 Inscricppcion en punto de venta
  // 3 inscripcion por codigo

  if (formaDeInscripcionparam === 1) {
    atleteData.tipoRegistro = formaDeInscripcionparam;
    atleteData.statusPago = {
      status: "pendiente",
      formaInscripcion: "en linea",
      formaPago: "",
      fechaPago: "",
      serverTime: firebase.database.ServerValue.TIMESTAMP,
      idOperacion: 0,
    };
  } else if (formaDeInscripcionparam === 2) {
    atleteData.tipoRegistro = formaDeInscripcionparam;
    atleteData.statusPago = {
      status: "ok",
      formaInscripcion: "punto de Venta",
      formaPago: "efectivo",
      fechaPago: fechahoraNew(),
      serverTime: firebase.database.ServerValue.TIMESTAMP,
      idOperacion: 0,
    };
  } else if (formaDeInscripcionparam === 3) {
    atleteData.tipoRegistro = formaDeInscripcionparam;
    atleteData.statusPago = {
      status: "ok",
      formaInscripcion: "Codigo de inscripción",
      formaPago: "efectivo",
      fechaPago: fechahoraNew(),
      serverTime: firebase.database.ServerValue.TIMESTAMP,
      idOperacion: 0,
    };
  } else if (formaDeInscripcionparam === 4) {
    atleteData.tipoRegistro = 2; // seteo a 2 para ver enviar correo como ya pagado
    atleteData.statusPago = {
      status: "ok",
      formaInscripcion: "en linea",
      formaPago: "efectivo",
      fechaPago: fechahoraNew(),
      serverTime: firebase.database.ServerValue.TIMESTAMP,
      idOperacion: 0,
    };
  }

  var route = `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}`;
  var inscritoKey = fb.db.ref().child(route).push().key;

  var updates = {};

  updates[`${route}${inscritoKey}/`] = atleteData;

  var ref = fb.db.ref(`${route}${inscritoKey}/`);
  return (dispatch) => {
    fb.db
      .ref()
      .update(updates)
      .then(function () {
        ref.on("value", (snapshot) => {
          console.log(snapshot.val());
          dispatch({
            type: types.REGISTRY_PARTICIPANT_DATA,
            registryParticipantData: snapshot.val(),
            registryParticipantKey: snapshot.key,
            registryError: null,
          });
        });
      })
      .catch(function (error) {
        dispatch({
          type: types.REGISTRY_PARTICIPANT_DATA,
          registryParticipantData: null,
          registryParticipantKey: null,
          registryError: error,
        });
      });
  };
}
// --- Registro de varios atletas antes de un solo pago ---
// Estas dos funciones son planas (no thunks, no usan dispatch) porque el
// grupo de atletas se lleva en el estado del propio componente
// EventRegistryPublicForm.jsx, no en Redux — registryParticipantData/
// registryParticipantKey del store están pensados para UN atleta "actual" a
// la vez (usan un listener .on() persistente) y se quedarían mal si se
// reusaran para guardar varios atletas en la misma sesión. No tocan ni
// reusan registryParticipantDataFunc para no arriesgar el flujo normal de
// un solo atleta, que sigue exactamente igual que antes.

// Guarda un atleta como registro pendiente (mismo shape que un registro
// tipo 1 normal: tipoRegistro=1, statusPago "pendiente") y devuelve una
// promesa con el inscritoKey ya generado.
export function guardarAtletaPendienteEnGrupo(eventoIndex, atleteData, userID) {
  const datos = { ...atleteData };
  datos.usuarioRegistra = userID === undefined ? "No registrado" : userID;
  datos.fechaRegistro = fechahoraNew();
  datos.serverTime = firebase.database.ServerValue.TIMESTAMP;
  datos.tipoRegistro = 1;
  datos.statusPago = {
    status: "pendiente",
    formaInscripcion: "en linea",
    formaPago: "",
    fechaPago: "",
    serverTime: firebase.database.ServerValue.TIMESTAMP,
    idOperacion: 0,
  };

  const route = `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}`;
  const inscritoKey = fb.db.ref().child(route).push().key;
  const updates = {};
  updates[`${route}${inscritoKey}/`] = datos;

  return fb.db
    .ref()
    .update(updates)
    .then(() => ({ inscritoKey, atleteData: datos }));
}

// Sobreescribe el `order` de un registro ya guardado — se usa al armar el
// resumen del grupo, justo antes de pagar, para consolidar la orden del
// líder (sus propios ítems + un resumen por cada atleta vinculado + la
// comisión sobre el total) y para agregar a cada atleta adicional el ítem
// que lleva su pago a $0.
export function actualizarOrdenDeRegistro(eventoIndex, inscritoKey, order) {
  const route = `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}${inscritoKey}/order`;
  return fb.db.ref(route).set(order);
}

// Quita a un atleta del grupo antes de pagar (o cancela el grupo completo,
// llamándola para cada inscritoKey). Marca el registro pendiente como
// borrado, mismo campo que ya usa el resto del sistema para registros
// eliminados — no dispara ningún cobro ni correo, el registro sigue sin
// pago (tipoRegistro=1, statusPago "pendiente").
export function marcarAtletaRemovidoDelGrupo(eventoIndex, inscritoKey) {
  const route = `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}${inscritoKey}/borrado`;
  return fb.db.ref(route).set(true);
}

export function registryFormDataFunc(eventoIndex, formId, formData) {
  //resetRegistryParticipantData();
  console.log("Guardar Datos formulario");

  var route = `${fb.EventosCompletos}${eventoIndex}/${fb.formsData}/${formId}/`;
  var itemKey = fb.db.ref().child(route).push().key;

  var updates = {};
  formData.date = new Date().getTime();

  updates[`${route}${itemKey}/`] = formData;

  var ref = fb.db.ref(`${route}${itemKey}/`);
  return (dispatch) => {
    fb.db
      .ref()
      .update(updates)
      .then(function () {
        ref.on("value", (snapshot) => {
          console.log(snapshot.val());
          dispatch({
            type: types.REGISTRY_FORM_DATA,
            registryFormData: snapshot.val(),
            registryFormKey: snapshot.key,
            registryError: null,
          });
        });
      })
      .catch(function (error) {
        dispatch({
          type: types.REGISTRY_FORM_DATA,
          registryFormData: null,
          registryFormKey: null,
          registryError: error,
        });
      });
  };
}


export function getallDataForConfirmationFunc(eventoIndex, inscritoKey) {
  console.log("registryParticipantDataConfirm", inscritoKey);
  console.log("registryParticipantDataConfirm", eventoIndex);

  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.InscripcionesConfiguracion}`
  );

  return (dispatch) => {
    const participantRef = fb.db.ref(
      "/eventosCompletos/" +
      eventoIndex +
      "/inscritos/listadoInscritos/" +
      inscritoKey
    );

    const configRef = fb.db.ref(
      "/eventosCompletos/" +
      eventoIndex +
      "/inscripcionesConfiguracion/"
    );

    // Listener para configuración
    const configListener = (snapshot) => {
      console.log("registryParticipantDataConfirm", snapshot.val());
      dispatch({
        type: types.REGISTRY_CONFIGURATION,
        registryConfiguration: snapshot.val(),
      });
    };

    ref.on("value", configListener);

    // Listener para inscrito (tiempo real)
    const participantListener = (snap) => {
      console.log("registryParticipantDataConfirm", snap.val());

      dispatch({
        type: types.REGISTRY_PARTICIPANT_DATA,
        registryParticipantData: snap.val(),
        registryParticipantKey: snap.key,
        registryError: null,
      });

      configRef
        .once("value")
        .then((snap) => {
          console.log("registryParticipantDataConfirm", snap.val());

          dispatch({
            type: types.REGISTRY_CONFIGURATION,
            registryConfiguration: snap.val(),
          });
        })
        .catch((error) => {
          console.log("error inscripcionesConfiguracion", error);
        });
    };

    participantRef.on("value", participantListener);

    // función de limpieza (muy importante)
    return () => {
      ref.off("value", configListener);
      participantRef.off("value", participantListener);
    };
  };
}
export function getallDataForConfirmationFuncOLD(eventoIndex, inscritoKey) {
  // 	//resetRegistryParticipantData();
  // 	console.log("get inscritos data para confirmación");
  console.log("registryParticipantDataConfirm", inscritoKey);
  console.log("registryParticipantDataConfirm", eventoIndex);
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.InscripcionesConfiguracion}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      console.log("registryParticipantDataConfirm", snapshot.val());
      dispatch({
        type: types.REGISTRY_CONFIGURATION,
        registryConfiguration: snapshot.val(),
      });
      return fb.db
        .ref(
          "/eventosCompletos/" +
          eventoIndex +
          "/inscritos/listadoInscritos/" +
          inscritoKey
        )
        .on("value")
        .then((snap) => {
          console.log("registryParticipantDataConfirm", snap.val());
          dispatch({
            type: types.REGISTRY_PARTICIPANT_DATA,
            registryParticipantData: snap.val(),
            registryParticipantKey: snap.key,
            registryError: null,
          });
          return fb.db
            .ref(
              "/eventosCompletos/" +
              eventoIndex +
              "/inscripcionesConfiguracion/"
            )
            .once("value");
        })
        .then((snap) => {
          console.log("registryParticipantDataConfirm", snap.val());

          dispatch({
            type: types.REGISTRY_CONFIGURATION,
            registryConfiguration: snap.val(),
          });
        });
    });
  };


}
export function getRegistryDataFunc(eventoIndex, inscritoKey) {
  // 	//resetRegistryParticipantData();
  // 	console.log("get inscritos data para confirmación");
  console.log("inscritoKey", inscritoKey);
  console.log("inscritoKey", eventoIndex);
  return (dispatch) => {
    fb.db
      .ref(
        "/eventosCompletos/" +
        eventoIndex +
        "/inscritos/listadoInscritos/" +
        inscritoKey
      )
      .on("value")
      .then((snap) => {
        console.log("registryParticipantData", snap.val());
        dispatch({
          type: types.REGISTRY_PARTICIPANT_DATA,
          registryParticipantData: snap.val(),
          registryParticipantKey: snap.key,
          registryError: null,
        });
      });
  };

}
export function getallDataForConfirmationFuncGeneric(eventoIndex, inscritoKey) {
  // 	//resetRegistryParticipantData();
  // 	console.log("get inscritos data para confirmación");
  console.log("inscritoKey", inscritoKey);
  console.log("inscritoKey", eventoIndex);
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.InscripcionesConfiguracion}`
  );
  return (dispatch) => {
    dispatch(detalleEvento(eventoIndex));
    dispatch(eventSubEventsRegistry(eventoIndex));
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      dispatch({
        type: types.REGISTRY_CONFIGURATION,
        registryConfiguration: snapshot.val(),
      });
      return fb.db
        .ref(
          "/eventosCompletos/" +
          eventoIndex +
          "/inscritos/listadoInscritos/" +
          inscritoKey
        )
        .once("value")
        .then((snap) => {
          console.log("registryParticipantData", snap.val());
          dispatch({
            type: types.REGISTRY_PARTICIPANT_DATA,
            registryParticipantData: snap.val(),
            registryParticipantKey: snap.key,
            registryError: null,
          });
          return fb.db
            .ref(
              "/eventosCompletos/" +
              eventoIndex +
              "/inscripcionesConfiguracion/"
            )
            .once("value");
        })
        .then((snap) => {
          dispatch({
            type: types.REGISTRY_CONFIGURATION,
            registryConfiguration: snap.val(),
          });
        });
    });
  };

  //   return db.ref('/eventosCompletos/'+eventoIndex+"/inscritos/listadoInscritos/"+inscritoKey).once('value')
  // 	.then(snap => {
  // 	  jsonData.datos = snap.val();
  //   return db.ref('/eventosCompletos/'+eventoIndex+'/inscripcionesConfiguracion/').once('value');
  // 	}).then(snap => {
  // 	  jsonData.inscripcionesConfiguracion = snap.val();
  // 	  JSONFormInscripcion = jsonData.inscripcionesConfiguracion;
  // 	  setBaseCurrency();

  //   return db.ref('/eventosCompletos/'+eventoIndex+'/detalleEvento/').once('value');
  // 	}).then(snap => {
  // 	  jsonData.detalleEvento = snap.val();
  //   return db.ref('/eventosCompletos/'+eventoIndex+'/modalidades/').once('value');
  // 	}).then(snap => {
  // 	  jsonData.modalidades = snap.val();

  // 	  return;
  // 	}).then(()=>{
  // 		if(descarga){
  // 		  console.log("descargar automatico");
  // 		  return setTimeout(()=> { return downloadDeslindePDFHTML(jsonData);},100)
  // 		  //return downloadDeslindePDF(jsonData);
  // 		}else {
  // 		  return;
  // 		}
  // 	});
}
